import type { ICRMCase } from '../../../Interfaces/ICRMCase';

interface ICrmCasesPayload {
  cases?: ICRMCase[];
  Cases?: ICRMCase[];
}

export function canReuseLoadedCrmCasesForBulk(
  isLoading: boolean,
  hasError: boolean,
  totalCount: number,
  loadedCaseCount: number,
  searchString: string
): boolean {
  return !isLoading && !hasError && !searchString && totalCount <= loadedCaseCount;
}

export function getCrmCasesFromPayload(payload?: ICrmCasesPayload | null): ICRMCase[] {
  return payload?.cases ?? payload?.Cases ?? [];
}
